module.exports = __webpack_public_path__ + "img/photoAlbum2.c33f5c63.jpg";